import React from 'react';
import PropTypes from 'prop-types';

const HeroSection = ({
  backgroundImage,
  title,
  description,
  rightImage,
  rightImageAlt = 'hero-image',
  className = '',
  contentClassName = '',
  titleClassName = '',
  descriptionClassName = '',
  rightImageClassName = '',
}) => {
  return (
    <section
      className={`relative bg-cover bg-center ${className}`}
      style={{ lineHeight: 0 }}
    >
      <img
        src={backgroundImage}
        alt="hero-background"
        className="h-[550px] w-full object-cover"
      />
      <div
        className={`absolute inset-0 flex flex-col-reverse md:flex-row justify-end md:justify-center items-center gap-10 px-5 py-12 md:px-32 md:py-9 md:pb-32 ${contentClassName}`}
      >
        <div className="flex flex-col justify-start md:justify-center items-center md:items-start gap-5 w-full md:w-[608px] flex-shrink-0">
          <h1
            className={`text-2xl md:text-4xl font-semibold leading-[36px] md:leading-[52px] text-white text-center md:text-left ${titleClassName}`}
          >
            {title}
          </h1>
          <p
            className={`text-base font-mark-ot font-normal leading-6 text-white text-center md:text-left ${descriptionClassName}`}
          >
            {description}
          </p>
        </div>
        {rightImage && (
          <img
            src={rightImage}
            alt={rightImageAlt}
            className={`max-w-1/2 h-auto md:max-w-full md:h-[400px] md:max-h-[400px] ${rightImageClassName}`}
          />
        )}
      </div>
    </section>
  );
};

HeroSection.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  rightImage: PropTypes.string,
  rightImageAlt: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  rightImageClassName: PropTypes.string,
};

export default HeroSection;
